<template>
  <Grid gaf="column" justify-content="space-between" align-items="center" class="opaque-header q-pl-xl q-pr-lg q-py-sm">
    <div class="text-subtitle-2 text-secondary-2">
      Subscription list view
      <HelpPageBtn :page="__guide.subscriptionPage" />
    </div>

    <Grid gaf="column" gap="var(--r-space-md)" align-items="center">
      <ExportBtn :loading="exportLoading" @click="$emit('export')" />

      <RBtn size="small" type="text" @click="$emit('toggle-edit-mode')">
        <Grid gaf="column" gap="var(--r-space-xs)" align-items="center">
          <EditIcon class="edit-icon" />

          <div class="text-overline-1 text-primary-1">
            {{ editMode ? 'Done editing' : 'Edit mode' }}
          </div>
        </Grid>
      </RBtn>

      <RBtn :disable="editMode" size="small" type="tertiary" @click="$emit('create-new-subscription')">
        create new subscription
      </RBtn>

      <RBtn size="small" type="primary" @click="$emit('clear-filters')">
        Clear filters
      </RBtn>

      <ShowHideCols :ag-grid="agGrid" />
    </Grid>
  </Grid>
</template>

<script>
// Libraries
import { mapState } from 'vuex'
// Components
import ShowHideCols from '@/ag-grid/components/show-hide-cols/ShowHideCols'
import HelpPageBtn from '@/reusable/base-components/HelpPageBtn'
import EditIcon from '@/ui/icons/EditIcon'
import ExportBtn from '@/reusable/ExportBtn'

export default {
  components: {
    ShowHideCols,
    HelpPageBtn,
    EditIcon,
    ExportBtn
  },

  props: {
    agGrid: Object
  },

  computed: {
    ...mapState('lv-subscriptions', ['editMode', 'exportLoading'])
  }
}
</script>

<style lang="scss" scoped>
.opaque-header {
  ::v-deep .edit-icon {
    path {
      fill: var(--r-primary-1);
    }
  }
}
</style>
